import { email, firstName, lastName, phone, privacyAgreement } from '@/schemas';
import * as Yup from 'yup';

const contactFormSchema = Yup.object({
  designation: Yup.string()
    .required('Bitte wählen Sie eine Anrede aus.')
    .oneOf(['Herr', 'Frau', 'Divers'], 'Bitte wählen Sie eine Anrede aus.'),
  firstName,
  lastName,
  email,
  phone,
  message: Yup.string().required('Bitte geben Sie Ihre Nachricht ein.'),
  marketingAgreement: Yup.boolean(),
  privacyAgreement,
});

export default contactFormSchema;
